import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { pickAFileSliceDispatch, refreshLoadedFileSliceDispatch } from "../../Constants/ReduxConstants";
import { ReduxHelpers } from "../../Helpers/ReduxHelpers";

interface RootState {
    refreshLoadedFile: { isLoading: boolean };
    pickAFile: { 
        fileLength: number | null; 
        fileName: string;
        filePath: string;
        currentDataContents: string;
    };
    apiResponseModal: { openedFileFromApi: boolean };
}

const RefreshLoadedFile: React.FC = () => {
    const isLoading = useSelector((state: RootState) => state.refreshLoadedFile.isLoading);
    const fileLength = useSelector((state: RootState) => state.pickAFile.fileLength);
    const currentDataContents = useSelector((state: RootState) => state.pickAFile.currentDataContents);

    const openedFileFromApi = useSelector((state: RootState) => state.apiResponseModal.openedFileFromApi);

    const dispatch = useDispatch();

    const { CreateContentsFromStates } = ReduxHelpers();

    // In web mode, we can only refresh the in-memory state, not reload from file
    function RefreshCurrentState() {
        dispatch({ type: refreshLoadedFileSliceDispatch.setIsLoading, payload: true });

        if (currentDataContents) {
            const parsedValues = JSON.parse(currentDataContents);
            CreateContentsFromStates(parsedValues);
        }

        dispatch({ type: refreshLoadedFileSliceDispatch.setIsLoading, payload: false });
    }

    return (
        <button 
            disabled={fileLength == null || isLoading || openedFileFromApi} 
            onClick={RefreshCurrentState} 
            title="Refresh Current State"
        >
            Refresh State
        </button>
    );
};

export default RefreshLoadedFile;